// react and mui stuff
import { Dispatch, SetStateAction, useContext,  } from 'react';
import { useLocation, useNavigate } from "react-router-dom"
import { UserContext } from '../../utils/contexts';

import { useColorScheme } from '@mui/joy/styles';
import List from '@mui/joy/List';
import ListItem from '@mui/joy/ListItem';
import ListItemButton from '@mui/joy/ListItemButton';
import ListItemDecorator from '@mui/joy/ListItemDecorator';
import ListItemContent from '@mui/joy/ListItemContent';
import Typography from '@mui/joy/Typography';

// custom components
import SidebarItems from '../../data/sidebarItems';


type props = {
  setDrawerOpen?: Dispatch<SetStateAction<boolean>>
}

export default function Navigation({setDrawerOpen}: props) {
  const loc = useLocation()
  const nav = useNavigate()
  const { user } = useContext(UserContext)
  const mode = useColorScheme()
  if (!user) return (<div></div>)
  const items = SidebarItems(user, mode.mode);
  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%", justifyContent: "space-between" }}>
      <List size="sm" sx={{ '--ListItem-radius': '8px', '--List-gap': '4px', position: "sticky", top: 80 }}>
        {items.map(item => (
          <ListItem key={item.link}>
            <ListItemButton selected={loc.pathname.startsWith(`/${item.link}`)} onClick={() => {
              nav(item.link);
              if (setDrawerOpen) setDrawerOpen(false);
            }}>
              <ListItemDecorator>
                {item.icon}
              </ListItemDecorator>
              <ListItemContent>
                {item.name}
              </ListItemContent>
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Typography level='body-xs'>LDS Gamers is not affiliated with nor endorsed by The Church of Jesus Christ of Latter-day Saints. The views expressed herein do not represent the official position of the Church.</Typography>
    </div>
  );
}